import { Search, X } from 'lucide-react';
import { cn } from '@/utils/style';
import { Input } from './Input';

interface SearchInputProps {
  search: string;
  setSearch: (search: string) => void;
  placeholder?: string;
}

export function SearchInput(props: SearchInputProps) {
  const { search, setSearch, placeholder } = props;
  const isActive = search !== '';

  return (
    <div className="relative w-64 shrink-0">
      <Input
        className={cn(isActive && 'border-pink-600 pr-8')}
        icon={<Search className={isActive ? 'text-pink-600' : 'text-gray-500'} />}
        placeholder={placeholder || 'Rechercher...'}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      {isActive && (
        <button
          type="button"
          title="Effacer la recherche"
          aria-label="Effacer la recherche"
          onClick={() => setSearch('')}
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-0.5 text-gray-500 hover:bg-gray-100 hover:text-gray-900"
        >
          <X className="size-4" />
        </button>
      )}
    </div>
  );
}
